import Footer from "_shared/_views/footers/footer";
import { usePagePlacesFooter } from "_shared/_views/footers/page-footer-placement";
import { ProposalContentColumn } from "work/proposals/_views/_shared/proposal-styled-components";
import type React from "react";

/**
 * A proposal page's content with the application footer under it, beside the side panel column. The
 * draft, active and archived pages each draw it, so the footer sits in the same place on all three
 * and none of their panels stops short of the foot of the window (#6911).
 */
export default function ProposalPageContent(props: Readonly<{ children: React.ReactNode }>) {
  usePagePlacesFooter();
  return (
    <ProposalContentColumn data-testid="proposal-page-content">
      {props.children}
      <Footer />
    </ProposalContentColumn>
  );
}
